import React from "react";
import "./FormContainerHeader.css";

const FormContainerHeader = (props) => {
  return (
    <div>
      {props.hasCounter ? (
        <span className="matching-criteria-counter">
          Criteria {props.step}/7
        </span>
      ) : null}

      {props.hasImage ? (
        <div className="header-image-container">
          <img
            src={props.imageSrc}
            alt={props.imageAlt}
            className="header-image"
          />
        </div>
      ) : null}

      <h1 className="headline-3">{props.headerText}</h1>

      {props.hasQuote ? (
        <p className="body-text matching-criteria-note">{props.quote}</p>
      ) : null}
    </div>
  );
};

export default FormContainerHeader;
